import { useMutation } from "react-query";

import { useAuth, useMessage } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import { FreebieRuleStatus, FreebieRuleType } from "../../utils/enums";

export interface IUpdateFreebieRuleParameter {
    id: string;
    name?: string;
    type?: FreebieRuleType;
    status?: FreebieRuleStatus;
    priority?: number;
    minCartValue?: number | null;
    discountCode?: string | null;
    quantity?: number;
    startsAt?: Date | null;
    endsAt?: Date | null;
    triggerVariantIds?: string[];
    freebieVariantIds?: string[];
}

export const useUpdateFreebieRule = (queryKey: string | string[]) => {
    const auth = useAuth();
    const { showError, showSuccess } = useMessage();
    return useMutation({
        mutationFn: async (parameters: IUpdateFreebieRuleParameter) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot update freebie rule without authorization token.",
                );
            }

            return await api.freebieRule.updateFreebieRule({
                ...parameters,
                token: auth.token,
            });
        },
        onSuccess: () => {
            showSuccess("Freebie rule updated successfully");
        },
        onError: () => {
            showError("Something went wrong");
        },
    });
};
